export default "__VITE_ASSET__GW22SucR__"